import { defineStore } from 'pinia';

export type IHealthStatus = 'healthy' | 'unhealthy' | 'degraded';

export interface IHealthCheck {
    status: 'up' | 'down';
    latency_ms: number;
}

export interface IHealthChecks {
    database?: IHealthCheck;
    blob_storage?: IHealthCheck;
}

export interface IHealthState {
    status: IHealthStatus | null;
    version: string | null;
    timestamp: string | null;
    checks: IHealthChecks | null;
}

const useHealthStore = defineStore('health', {
    state: (): IHealthState => ({
        status: null,
        version: null,
        timestamp: null,
        checks: null,
    }),

    getters: {
        isHealthy: (state) => state.status === 'healthy',
        backendVersion: (state) => state.version,
    },

    actions: {
        setHealth(payload: IHealthState) {
            this.status = payload.status;
            this.version = payload.version;
            this.timestamp = payload.timestamp;
            this.checks = payload.checks;
        },

        reset() {
            this.$reset();
        },
    },
});

export default useHealthStore;
